// 7-bag randomizer: every cycle of 7 pieces shuffles all 7 tetrominoes.

import type { PieceType } from '../types';
import { PIECE_TYPES } from '../types';
import { mulberry32 } from '../utils/rng';

export class Bag {
  private rng: () => number;
  private buffer: PieceType[] = [];

  constructor(seed?: number) {
    this.rng = mulberry32(seed ?? (Math.random() * 2 ** 32) >>> 0);
    this.refill();
  }

  private refill(): void {
    const next = [...PIECE_TYPES] as PieceType[];
    // Fisher-Yates
    for (let i = next.length - 1; i > 0; i--) {
      const j = Math.floor(this.rng() * (i + 1));
      const tmp = next[i]!;
      next[i] = next[j]!;
      next[j] = tmp;
    }
    this.buffer.push(...next);
  }

  /** Peek the next N pieces without consuming. */
  peek(count: number): PieceType[] {
    while (this.buffer.length < count) this.refill();
    return this.buffer.slice(0, count);
  }

  /** Consume and return the next piece. */
  next(): PieceType {
    if (this.buffer.length === 0) this.refill();
    return this.buffer.shift()!;
  }
}
